<template>
    <div>
        <div class="wrap-document">
            <p class="title">
                DOKUMEN PEMBERITAHUAN ADANYA RISIKO YANG HARUS DISAMPAIKAN OLEH PIALANG BERJANGKA UNTUK KONTRAK BERJANGKA MULTILATERAL
            </p>
            <div class="content">
                Dokumen Pemberitahuan Adanya Risiko ini disampaikan kepada Anda sesuai dengan Pasal 50 ayat (2) Undang-Undang Nomor 32 Tahun 1997 tentang Perdagangan
                Berjangka Komoditi sebagaimana diubah dengan Undang-Undang Nomor 10 Tahun 2011 tentang Perubahan Undang- Undang Nomor 32 Tahun 1997 tentang
                Perdagangan Berjangka Komoditi.

                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                Maksud dokumen ini adalah memberitahukan bahwa kemungkinan kerugian atau keuntungan dalam perdagangan Kontrak Berjangka bisa mencapai jumlah yang
                sangat besar. Oleh karena itu, Anda harus berhati- hati dalam memutuskan untuk melakukan transaksi, apakah kondisi keuangan Anda mencukupi.
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">
                    1.
                    <u
                        >Perdagangan Kontrak Berjangka belum tentu layak bagi semua investor.Anda dapat menderita kerugian dalam jumlah besar dan dalam jangka waktu
                        singkat.</u
                    >
                </p>
                Jumlah kerugian uang dimungkinkan dapat melebihi jumlah uang yang pertama kali Anda setor (Margin awal) ke Pialang Berjangka Anda. Anda mungkin
                menderita kerugian seluruh Margin dan Margin tambahan yang ditempatkan pada Pialang Berjangka untuk mempertahankan posisi Kontrak Berjangka Anda. Hal
                ini disebabkan Perdagangan Berjangka sangat dipengaruhi oleh mekanisme leverage, dimana dengan jumlah investasi dalam bentuk yang relatif kecil dapat
                digunakan untuk membuka posisi dengan aset yang bernilai jauh lebih tinggi. Apabila Anda tidak siap dengan risiko seperti ini, sebaiknya Anda tidak
                melakukan perdagangan Kontrak Berjangka.
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">
                    2.
                    <u
                        >Perdagangan Kontrak Berjangka mempunyai risiko dan mempunyai kemungkinan kerugian yang tidak terbatas yang jauh lebih besar dari jumlah uang
                        yang disetor (Margin) ke Pialang Berjangka.</u
                    >
                </p>
                Kontrak Berjangka sama dengan produk keuangan lainnya yang mempunyai risiko tinggi, Anda sebaiknya tidak menaruh risiko terhadap dana yang Anda tidak
                siap untuk menderita rugi, seperti tabungan pensiun, dana kesehatan atau dana untuk keadaan darurat, dana yang disediakan untuk pendidikan atau
                kepemilikan rumah, dana yang diperoleh dari pinjaman pendidikan atau gadai, atau dana yang digunakan untuk memenuhi kebutuhan sehari-hari.

                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">
                    3. <u>Berhati-hatilah terhadap pernyataan bahwa Anda pasti mendapatkan keuntungan besar dari perdagangan Kontrak Berjangka.</u>
                </p>
                Meskipun perdagangan Kontrak Berjangka dapat memberikan keuntungan yang besar dan cepat, namun hal tersebut tidak pasti, bahkan dapat menimbulkan
                kerugian yang besar dan cepat juga. Seperti produk keuangan lainnya, tidak ada yang dinamakan “pasti untung”.
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">
                    4.
                    <u
                        >Disebabkan adanya mekanisme leverage dan sifat dari transaksi Kontrak Berjangka, Anda dapat merasakan dampak bahwa Anda menderita kerugian
                        dalam waktu cepat.</u
                    >
                </p>
                Keuntungan maupun kerugian dalam transaksi Kontrak Berjangka akan langsung dikredit atau didebet ke rekening Anda, paling lambat secara harian.
                Apabila pergerakan di pasar terhadap Kontrak Berjangka menurunkan nilai posisi Anda dalam Kontrak Berjangka, Anda diwajibkan untuk menambah dana
                untuk pemenuhan kewajiban Margin ke Pialang Berjangka. Apabila rekening
            </div>
        </div>
        <div class="wrap-document">
            <div class="content">
                Anda berada dibawah minimum Margin yang telah ditetapkan Lembaga Kliring Berjangka atau Pialang Berjangka, maka posisi Anda dapat dilikuidasi pada
                saat rugi, dan Anda wajib menyelesaikan defisit (jika ada) dalam rekening Anda.
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">5. <u>Pada saat pasar dalam keadaan tertentu, Anda mungkin akan sulit atau tidak mungkin melikuidasi posisi.</u></p>
                Pada umumnya Anda harus melakukan transaksi offset jika ingin melikuidasi posisi dalam Kontrak Berjangka. Apabila Anda tidak dapat melikuidasi posisi
                Kontrak Berjangka, Anda tidak dapat merealisasikan keuntungan pada nilai posisi tersebut atau mencegah kerugian yang lebih tinggi. Kemungkinan tidak
                dapat melikuidasi dapat terjadi, antara lain: jika perdagangan berhenti dikarenakan aktivitas perdagangan yang tidak lazim pada Kontrak Berjangka
                atau subjek Kontrak Berjangka, terjadi kerusakan sistem pada Bursa Berjangka atau Pialang Berjangka, atau posisi Anda berada dalam pasar yang tidak
                likuid. Bahkan apabila Anda dapat melikuidasi posisi tersebut, Anda mungkin terpaksa melakukannya pada harga yang menimbulkan kerugian besar.
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">
                    6.
                    <u
                        >Pada saat pasar dalam keadaan tertentu, Anda mungkin akan sulit atau tidak mungkin mengelola risiko atas posisi terbuka Kontrak Berjangka
                        dengan cara membuka posisi dengan nilai yang sama namun dengan posisi yang berlawanan dalam kontrak bulan yang berbeda, dalam pasar yang
                        berbeda atau dalam “subjek Kontrak Berjangka” yang berbeda.</u
                    >
                </p>
                Kemungkinan untuk tidak dapat mengambil posisi dalam rangka membatasi risiko yang timbul, contohnya: jika perdagangan dihentikan pada pasar yang
                berbeda disebabkan aktivitas perdagangan yang tidak lazim pada Kontrak Berjangka atau “subjek Kontrak Berjangka”
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">
                    7. <u>Anda dapat diwajibkan untuk menyelesaikan Kontrak Berjangka dengan penyerahan fisik dari “subjek Kontrak Berjangka”.</u>
                </p>
                Jika Anda mempertahankan posisi penyelesaian fisik dalam Kontrak Berjangka sampai hari terakhir perdagangan berdasarkan tanggal jatuh tempo Kontrak
                Berjangka, Anda akan diwajibkan menyerahkan atau menerima penyerahan “subjek Kontrak Berjangka” yang dapat mengakibatkan adanya penambahan biaya.
                Pengertian penyelesaian dapat berbeda untuk suatu Kontrak Berjangka dengan Kontrak Berjangka lainnya atau suatu Bursa Berjangka dengan Bursa
                Berjangka lainnya. Anda harus melihat secara teliti mengenai penyelesaian dan kondisi penyerahan sebelum membeli atau menjual Kontrak Berjangka
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">
                    8.
                    <u
                        >Anda dapat menderita kerugian yang disebabkan kegagalan sistem informasi.Sebagaimana yang terjadi pada setiap transaksi keuangan, Anda dapat
                        menderita kerugian jika amanat untuk melaksanakan transaksi Kontrak Berjangka tidak dapat dilakukan karena kegagalan sistem informasi di
                        Bursa Berjangka, penyelenggara maupun sistem informasi di Pialang Berjangka yang mengelola posisi Anda.</u
                    >
                </p>

                Kerugian Anda akan semakin besar jika Pialang Berjangka yang mengelola posisi Anda tidak memiliki sistem informasi cadangan atau prosedur yang layak.
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">
                    9. <u>Semua Kontrak Berjangka mempunyai risiko, dan tidak ada strategi berdagang yang dapat menjamin untuk menghilangkan risiko tersebut.</u>
                </p>
                Strategi dengan menggunakan kombinasi posisi seperti spread, dapat sama berisiko seperti posisi long atau short. Melakukan Perdagangan Berjangka
                memerlukan pengetahuan mengenai Kontrak Berjangka dan pasar berjangka.
            </div>
        </div>
        <div class="wrap-document">
            <div class="content">
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">10. <u>Strategi perdagangan harian dalam Kontrak Berjangka dan produk lainnya memiliki risiko khusus.</u></p>
                Seperti pada produk keuangan lainnya, pihak yang ingin membeli atau menjual Kontrak Berjangka yang sama dalam satu hari untuk mendapat keuntung an
                dari perubahan harga pada hari tersebut (“day traders”) akan memiliki beberapa risiko tertentu antara lain jumlah komisi yang besar, risiko terkena
                efek pengungkit (“exposure to leverage”), dan persaingan dengan pedagang profesional. Anda harus mengerti risiko tersebut dan memiliki pengalaman
                yang memadai sebelum melakukan perdagangan harian (“day trading”).
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">
                    11.
                    <u
                        >Menetapkan amanat bersyarat, seperti Kontrak Berjangka dilikuidasi pada keadaan tertentu untuk membatasi rugi (stop loss), mungkin tidak
                        akan dapat membatasi kerugian Anda sampai jumlah tertentu saja.</u
                    >
                </p>
                Amanat bersyarat tersebut mungkin tidak dapat dilaksanakan karena terjadi kondisi pasar yang tidak memungkinkan melikuidasi Kontrak Berjangka.
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">12. <u>Anda harus membaca dengan seksama dan memahami Perjanjian Pemberian Amanat</u></p>
                Dengan Pialang Berjangka Anda sebelum melakukan transaksi Kontrak Berjangka.

                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">
                    13. <u>Pernyataan singkat ini tidak dapat memuat secara rinci seluruh risiko atau aspek penting lainnya tentang Perdagangan Berjangka.</u>
                </p>
                Oleh karena itu Anda harus mempelajari kegiatan Perdagangan Berjangka secara cermat sebelum memutuskan melakukan transaksi.
                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <div class="content">
                <p class="sub-content">14. <u>Dokumen Pemberitahuan Adanya Risiko (Risk Disclosure) ini dibuat dan ditandatangani dalam Bahasa Indonesia.</u></p>

                <form>
                    <div class="form-group">
                        <input type="checkbox" name="chek" required />
                        <label>Saya sudah membaca dan memahami</label>
                    </div>
                </form>
            </div>
            <hr />
            <div class="content">
                <form>
                    <div class="form-group" @click="checkAll">
                        <input type="checkbox" name="check" required />
                        <label>Saya sudah membaca dan memahami semua persyaratan</label>
                    </div>
                </form>
            </div>
            <div class="penutup">
                <p class="title">PERNYATAAN MENERIMA PEMBERITAHUAN ADANYA RISIKO</p>
                <p>Dengan mengisi kolom “YA” di bawah, saya menyatakan bahwa saya telah menerima</p>
                <p class="resiko">"DOKUMEN PEMBERITAHUAN ADANYA RISIKO"</p>
                <p>mengerti dan menyetujui isinya</p>
            </div>
            <div class="persetujuan">
                <div class="ttd">
                    <p>Pernyataan menerima</p>
                    <div class="pernyataan">
                        <input type="radio" name="confirmRisk" :value="true" v-model="valueStetment" required @change="handleValue" />
                        <label>Ya</label>
                        <input type="radio" :value="false" v-model="valueStetment" @change="handleValue" />
                        <label>Tidak</label>
                    </div>
                </div>
                <div class="ttd">
                    <p>Menerima pada Tanggal</p>
                    <div>
                        {{ currentDate | formatDateTime }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        statementRisk: Boolean,
        dataPrint: Object,
    },
    data() {
        return {
            currentDate: "",
        };
    },
    computed: {
        valueStetment() {
            return this.statementRisk;
        },
    },
    mounted() {
        if (this.dataPrint.tanggal_diterima) {
            this.currentDate = this.dataPrint.tanggal_diterima;
        } else {
            this.currentDate = new Date();
        }
        let dataCheck = document.getElementsByName("chek");
        let validateCheck = document.getElementsByName("check");
        if (this.valueStetment) {
            validateCheck[0].checked = true;
            for (let i = 0; i < dataCheck.length; i++) {
                dataCheck[i].checked = true;
            }
        }
    },
    methods: {
        checkAll() {
            let data = document.getElementsByName("chek");
            for (let i = 0; i < data.length; i++) {
                data[i].checked = true;
            }
        },
        handleValue(e) {
            this.$emit("updateValue", e.target._value);
        },
    },
};
</script>

<style scoped>
/* .wrap-document {
    padding: 20px;
    border-radius: 5px;
    background: white;
    position: relative;
    color: black;
} */

.wrap-document {
    padding-inline: 5mm;
    /* width: 210mm; */
    height: 277mm;
    /* padding: 10mm; */
    margin: 0.5mm auto;
    /* border: 1px red solid; */
    border-radius: 5px;
    background: white;
    /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
    position: relative;
}

.top {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    margin-bottom: 25px;
}

.nomor {
    font-weight: bold;
}

.lampiran p {
    margin: 0;
    text-align: right;
}

.title {
    font-weight: bold;
    text-align: center;
    margin-bottom: 1rem;
    font-size: 14px;
}

.content {
    font-size: 12px;
    text-align: justify;
}

.sub-content {
    font-weight: 700;
}

form {
    margin: 20px 0;
    /*  */
    font-weight: 700;
}

label {
    margin-left: 15px;
    vertical-align: middle;
}

.penutup {
    text-align: center;
    font-size: 12px;
}

.penutup p {
    margin: 0;
}

.resiko {
    font-weight: 700;
}

.persetujuan {
    width: 50%;
    font-size: 12px;
    margin: 1rem auto 3rem;
}

.persetujuan .ttd {
    display: flex;
}

.persetujuan p {
    width: 180px;
    margin-bottom: 0;
}

.pernyataan label {
    margin-left: 10px;
    vertical-align: middle;
    margin-right: 2rem;
}

.tanggal {
    margin-left: auto;
    margin-bottom: 10px !important;
}

.jabatan {
    margin-bottom: 70px !important;
}

.pt-abi {
    display: block !important;
    margin: 20px auto;
    width: 50%;
}

.pt-abi p {
    width: auto !important;
}

.footer {
    display: flex;
    font-size: 10px;
    justify-content: space-between;
}

@media (max-width: 768px) {
    .wrap-document {
        width: 100%;
        padding: 30px 0;
        height: 100%;
    }

    .title {
        margin: 20px auto !important;
    }

    .persetujuan {
        width: 100%;
    }
}
</style>
